import { render } from "./BoardData.vue?vue&type=template&id=30f43ade"
import script from "./BoardData.vue?vue&type=script&lang=js"
export * from "./BoardData.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__